module.exports = __webpack_public_path__ + "static/media/github.ea76ba6c.webp";